<template>
  <div class="animated fadeIn dashboard pa-6">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <div class="pa-6 d-flex flex-column">
          <div>
            <v-btn
              elevation="3"
              height="45"
              color="grey darken-1"
              class="me-3"
              outlined
              small
              style="border-radius: 6px !important; font-size: 17px !important"
              >n</v-btn
            >
            <b>ثبت فاکتور جدید</b>
          </div>
          <div class="mt-6">
            <v-btn
              elevation="3"
              height="45"
              color="grey darken-1"
              class="me-3"
              outlined
              small
              style="border-radius: 6px !important; font-size: 17px !important"
              >o</v-btn
            >
            <b>ثبت پیش‌فاکتور جدید</b>
          </div>
        </div>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      v-shortkey.once="['n']"
      @shortkey="goToNewInvoice()"
    ></i>
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      v-shortkey.once="['o']"
      @shortkey="goToNewProforma()"
    ></i>
    <!-- newInvoiceModal -->
    <!-- <v-dialog v-model="newInvoiceModal" persistent width="500">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey">انتخاب نوع فروش</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newInvoiceModal = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div>
          <h5 class="c-grey ms-7">نوع فروش خود را انتخاب کنید:</h5>
          <v-card-text class="custom-input mb-9 mt-5">
            <v-row>
              <v-col class="text-center">
                <v-btn
                  class="purple-mainBtn py-5"
                  width="150"
                  :to="'/shop/newinvoice/wholesale'"
                  >فاکتور فروش عمده</v-btn
                >
              </v-col>
              <v-col class="text-center">
                <v-btn
                  class="purple-mainBtn py-5"
                  width="150"
                  :to="'/shop/newinvoice/retail'"
                  >فاکتور فروش خرده</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  class="green-mainBtn py-5"
                  width="150"
                  :to="'/shop/newproforma/wholesale'"
                  >پیش فاکتور فروش عمده</v-btn
                >
              </v-col>
              <v-col class="text-center">
                <v-btn
                  class="green-mainBtn py-5"
                  width="150"
                  :to="'/shop/newproforma/retail'"
                  >پیش فاکتور فروش خرده</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog> -->
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <cube></cube>
      <p class="c-purple font-weight-bold mt-4">در حال بارگذاری اطلاعات...</p>
    </div>
    <div v-else>
      <!--<div class="mb-3">
        <v-btn @click="openNewInvoiceModal()" class="green-mainBtn"
          >ثبت فاکتور جدید</v-btn
        >
      </div>-->
      <v-row class="header">
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="purple-iconBox">
                <v-icon>$Warehouse</v-icon>
              </div>
              <span class="box-header">موجودی انبار</span>
            </div>
            <h5>{{ Number(dashboard.productSum).toLocaleString() }} کالا</h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="blue-iconBox">
                <v-icon>$Wallet</v-icon>
              </div>
              <span class="box-header">میزان فروش</span>
            </div>
            <h5>{{ Number(dashboard.totalIncome).toLocaleString() }} تومان</h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="red-iconBox">
                <v-icon>$Customer</v-icon>
              </div>
              <span class="box-header">تعداد مشتری</span>
            </div>
            <h5>{{ Number(dashboard.shopCustomers).toLocaleString() }} نفر</h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="green-iconBox">
                <v-icon>$Box</v-icon>
              </div>
              <span class="box-header">تعداد تنوع محصولات</span>
            </div>
            <h5>
              {{ Number(dashboard.warehouseItems).toLocaleString() }} نوع کالا
            </h5>
          </v-card>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-card class="common-card">
          <div class="d-flex flex-row">
            <div class="orange-iconBox mt-1">
              <v-icon>$Chart2</v-icon>
            </div>
            <span class="c-grey pt-3 ps-3">نمودار میزان درآمد</span>
          </div>

          <div class="mt-6" v-if="dashboard.incomes.labels.length">
            <Chart
              name="DashboardLineChart"
              type="line"
              v-if="showChart"
              :chartdata="dashboard.incomes"
              :options="optionsLine"
              height="160"
            >
            </Chart>
          </div>
          <div v-else class="pa-5 text-center">
            <hr />
            <h6 class="c-grey">تاکنون خریدی به ثبت نرسیده است.</h6>
            <hr />
          </div>
        </v-card>
      </div>
      <div class="mt-5">
        <v-row>
          <v-col lg="6" cols="12">
            <v-card class="common-card" style="height: 100%">
              <div class="d-flex flex-row">
                <div class="blue-iconBox">
                  <v-icon>$BoxChecked</v-icon>
                </div>
                <span class="c-grey ms-4 pt-2"
                  >پرفروش‌ترین کالاهای این ماه</span
                >
              </div>
              <div class="custom-table mt-5">
                <b-table
                  responsive
                  show-empty
                  stacked="sm"
                  :items="dashboard.bestSelling"
                  :fields="fields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        max-width: 300px;
                      "
                    >
                      {{
                        data.value
                          ? data.value.length > 40
                            ? data.value.slice(0, 40) + "..."
                            : data.value
                          : "-"
                      }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
          <v-col lg="6" cols="12">
            <v-card class="common-card" style="height: 100%">
              <div class="d-flex flex-row">
                <div class="blue-iconBox">
                  <v-icon>$FinishedBox</v-icon>
                </div>
                <span class="c-grey ms-4 pt-2">کالاهای با موجودی تمام شده</span>
              </div>
              <div class="custom-table mt-5">
                <b-table
                  responsive
                  show-empty
                  stacked="sm"
                  :items="dashboard.zero"
                  :fields="fields2"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        max-width: 300px;
                      "
                    >
                      {{
                        data.value.length > 40
                          ? data.value.slice(0, 40) + "..."
                          : data.value
                      }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Chart from "../../components/charts/Chart.vue";
import moment from "moment-jalaali";
export default {
  components: {
    Chart,
  },
  data() {
    return {
      newInvoiceModal: false,
      moment: moment,
      loaded: false,
      currentYear: moment(new Date()).format("jYYYY"),
      selectedYear: moment(new Date()).format("jYYYY"),
      years: [],
      dashboard: {},
      bestSelling: [],
      finishedGoods: [],
      dataLine: {},
      showChart: false,
      optionsLine: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "top",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 25,
              boxHeight: 8,
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            min: 0,
            title: {
              display: true,
              text: "میزان درآمد (میلیون تومان)",
              font: { family: "iransans" },
            },
            grid: {
              display: false,
            },
            ticks: {
              label: "میزان درآمد (میلیون تومان)",
              stepSize: 10,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      fields: [
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت (ریال)" },
        { key: "warehouseStocks", label: "موجودی انبار" },
      ],
      fields2: [
        { key: "name", label: "نام محصول" },
        { key: "price", label: "قیمت (ریال)" },
        { key: "purchaseCount", label: "تعداد فروش" },
      ],
      pageLoaded: false,
      guide: false,
    };
  },
  methods: {
    goToNewInvoice() {
      this.$router.push("/shop/newinvoice");
    },
    goToNewProforma() {
      this.$router.push("/shop/newproforma");
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openNewInvoiceModal() {
      this.newInvoiceModal = true;
    },
    getDashboard() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/dashboard/dashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.dashboard = res.data;
            setTimeout(() => {
              this.showChart = true;
              this.loaded = true;
              this.pageLoaded = true;
            }, 100);
          } else {
            this.toast(res.data, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getDashboard();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.dashboard {
  background-color: #e5e5e5 !important;
  border-radius: 15px;
  .header {
    .v-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 140px;

      .box-header {
        color: #656a81;
        padding-top: 7px;
        padding-right: 14px;
      }
      h5 {
        color: #4e536a;
        font-size: 20px;
        margin: 0;
      }
    }
  }
}
</style>
